import styled from "styled-components";
import { Icon } from "@components";

const AvatarContainer = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border-radius: 1000px;
  border: 1px solid var(--outline-variant);
`;

const StyledImg = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 1000px;
`;

type AvatarProps = {
  src?: string;
};

export const Avatar: React.FC<AvatarProps> = ({ src }) => {
  return (
    <AvatarContainer>
      {src ? (
        <StyledImg src={src} alt="avatar" />
      ) : (
        <Icon
          name="page-bars"
          size={32}
          color="var(--surface-container-highest)"
        />
      )}
    </AvatarContainer>
  );
};
